import { Loader2 } from "lucide-react";
import { useAppSelector } from "../../store/hooks";
import { statusLabel } from "../../hooks/useCopilotRuntime";

/**
 * Live activity shown after the latest message while the workflow is running.
 * Reads the pipeline stage from Redux (streamed via SSE `status` events).
 */
export function RunningStatusPill() {
  const status = useAppSelector((s) => s.copilotReducer.currentStatusText);
  const label = statusLabel(status);
  return (
    <div
      className="mb-3 flex items-center gap-2 py-1 text-neutral-400"
      role="status"
    >
      <Loader2 className="h-3.5 w-3.5 animate-spin text-sky-400" />
      <span className="text-xs">{label}</span>
    </div>
  );
}
